import { render, staticRenderFns } from "./ButtonTumbler.vue?vue&type=template&id=253c8875&"
import script from "./ButtonTumbler.vue?vue&type=script&lang=js&"
export * from "./ButtonTumbler.vue?vue&type=script&lang=js&"
import style0 from "./ButtonTumbler.vue?vue&type=style&index=0&id=253c8875&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports